import React from "react";

const NchLogoStackedBase = (props) => {

    return(
        <img  key={props.objectkey} 
            className = {`nchLogoStacked ${props.fieldclass || ""}`} 
            src={props.logourl}
            alt="National Children's Hospital" 
            crossOrigin="anonymous"                  
            onError={() => console.error('Image failed to load:', props.logourl)}
        />
    );
}
export default NchLogoStackedBase;